import React from "react";
import { ButtonSize, ButtonTypes } from "utils/interface.utils";
import { Colors}  from "utils/theme.utils";
// import Loader from "../loader/loader.ui";
import Assets from "imports/assets.import";
import "./primary_button.ui.scss";
import { Loader } from "utils/imports.utils";

interface IPrimaryButton {
  text?: String;
  color?: any;
  left_icon?: any;
  className?: any;
  // onClick?: (e: React.MouseEvent) => void;
  onClick?: any;
  backgroundColor?: string;
  disabled?: boolean;
  style?: any;
  right_icon?: any;
  activity?: boolean;
  type?: string;
  size?: string;
  fontFamily?: string;
  lineHeight?: string;
  textDecorationColor?: string;
  iconSize?: {
    width: string | number;
    height: string | number;
  },
  letterSpacing?: string;
}

const PrimaryButton = (props: IPrimaryButton) => {
  //logic
  const getButtonStyles = () => {
    if (props.size === ButtonSize.SMALL) {
      return "btn_small";
    } else if (props.size === ButtonSize.MEDIUM) {
      return "btn_medium";
    } else if (props.size === ButtonSize.LARGE) {
      return "btn_large";
    }
  };

  const getBgColor = () => {
    // Lime is the primary fill and always carries ink text. Lime is too light to be text, so text buttons are ink,
    // underlined so they still read as links.
    if (props.type === ButtonTypes.PRIMARY) {
      return { backgroundColor: Colors.primaryColor, color: Colors.onPrimary };
    } else if (props.type === ButtonTypes.PRIMARY_GRADIENT) {
      return { backgroundColor: Colors.primaryColor, color: Colors.onPrimary }
    } else if (props.type === ButtonTypes.TERTIARY) {
      return { backgroundColor: Colors.colorTertiary, color: Colors.primaryTextColor }
    } else if (props.type === ButtonTypes.SECONDARY) {
      return { backgroundColor: Colors.white, color: Colors.primaryTextColor };
    } else if (props.type === ButtonTypes.OUTLINED) {
      return { backgroundColor: Colors.transparent, border: `1px solid ${Colors.buttonBorder}`, color: Colors.buttonOutlineText, borderRadius: "999px" };
    } else if (props.type === ButtonTypes.TEXT){
      return { backgroundColor: Colors.transparent, color: Colors.primaryTextColor, textDecoration: "underline" };
    } else if (props.type === ButtonTypes.TEXT_UNDERLINE) {
      return { backgroundColor: Colors.transparent, color: Colors.fontSecondary, textDecoration: "underline", textDecorationColor: props.textDecorationColor, textDecorationThickness: "1px", textDecorationSkipInk:"none", textUnderlinePosition:"from-font" };
    } else if (props.type === ButtonTypes.DISABLED){
      return { backgroundColor: Colors.primaryColor, color: Colors.onPrimary, opacity:0.3};
    }else {
      return { backgroundColor: props.backgroundColor };
    }
  };

  // Lime-filled buttons carry ink text, so their (white) icons are turned dark to match (see the stylesheet).
  const isOnLime = props.type === ButtonTypes.PRIMARY || props.type === ButtonTypes.PRIMARY_GRADIENT || props.type === ButtonTypes.DISABLED;

  return (
    <div
      role="button"
      aria-disabled={props.disabled || undefined}
      className={`${isOnLime ? 'button_on_lime ' : ''}${props.disabled ? `button_wrapper btn_disabled ${getButtonStyles()}` : `button_wrapper ${getButtonStyles()} `} ${
        props.className || ""
      }`}
      style={{
        ...getBgColor(),
        ...props.style,
        // A disabled button has to read as disabled. `.btn_disabled` carries no visual treatment,
        // and it could not win anyway -- getBgColor() and any caller `style` override are inline,
        // so they beat a class rule. Applying it last is what makes it hold for every button type.
        // 0.3 matches the opacity ButtonTypes.DISABLED already uses.
        ...(props.disabled ? { opacity: 0.3, cursor: "not-allowed" } : {}),
      }}
      onClick={(event: React.MouseEvent) => {
        if (!props.disabled && props.onClick) {
          props.onClick(event);
        }
      }}
    >
      {props.activity ? (
        <div className="primary_button_img">
          <Loader icon={props.type === ButtonTypes.OUTLINED ? Assets.activity_indicator: Assets.loader} />
        </div>
      ) : (
        <>
          {props.left_icon && (
            <div className="primary_button_img">
              <img src={props.left_icon} alt="icon" className="primary_btn_icon" style={{width:props.iconSize?.width, height:props.iconSize?.height}} />
            </div>
          )}
          {props.text && (
            <div style={{ color: props.color, fontFamily: props.fontFamily, lineHeight: props.lineHeight, letterSpacing: props.letterSpacing }} className="button_text">
              {props.text}
            </div>
          )}
          {props.right_icon && (
            <div className="primary_button_right_img">
              <img src={props.right_icon} alt="icon" className="primary_btn_icon" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PrimaryButton;
